import { ArticleType } from '@nemuru-eng/js-api-client';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { ApplicationStepContainer } from '@/components/modules/Application/components/_shared/components/ApplicationStepContainer';
import { ApplicationStepNav } from '@/components/modules/Application/components/_shared/components/ApplicationStepNav';
import { Section } from '@/components/modules/Application/components/_shared/components/Section/Section';
import { SectionTitle } from '@/components/modules/Application/components/_shared/components/Section/SectionTitle';
import { useContactInformation } from '@/components/modules/Application/components/ContactInformation/_shared/hooks/useContactInformation';
import { ContactInformationFormType } from '@/components/modules/Application/components/ContactInformation/_shared/schemas/contactInformationForm.schema';
import { CustomerContactDataForm } from '@/components/modules/Application/components/ContactInformation/components/CustomerContactDataForm';
import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

interface ContactInformationFormProps {
  showBirthDate: boolean;
}

export const ContactInformationForm = ({ showBirthDate }: ContactInformationFormProps) => {
  const {
    state: { orderReference1: orderReference1FromContext, cart },
  } = useApplicationContext();

  const { onPrev } = useApplicationNavigation();
  const { getTextIdTranslation } = useTranslation();
  const { submitContactInformation } = useContactInformation();

  const [loading, setLoading] = useState(false);

  const { handleSubmit, watch, setValue } = useFormContext();

  const documentNumber = watch('documentNumber');

  useEffect(() => {
    if (documentNumber && !orderReference1FromContext) {
      setValue('orderReference1', documentNumber);
    }
  }, [documentNumber]);

  const isReferenceValid = !!orderReference1FromContext;

  const isOrderReferenceOptional = cart?.cartArticleType() === ArticleType.AUTOMOBILE;

  return (
    <ApplicationStepContainer>
      <Section>
        <SectionTitle title={'CUSTOMER_CONTACT_DATA'} subtitle={'FILL_CUSTOMER_CONTACT_DATA'} />
        <CustomPaper fill="paper" style={{ paddingBottom: 40 }}>
          <CustomerContactDataForm fieldVariant={FieldVariant.form} showBirthDate={showBirthDate} />
        </CustomPaper>
      </Section>
      <ApplicationStepNav
        loading={loading}
        onNext={handleSubmit(async (data) => {
          try {
            setLoading(true);
            await submitContactInformation(data as ContactInformationFormType);
          } catch (error) {
            console.error(error);
          } finally {
            setLoading(false);
          }
        })}
        onPrev={onPrev}
        disableOnNext={!isOrderReferenceOptional && !isReferenceValid}
        tooltipOnNextDisabled={!isReferenceValid && getTextIdTranslation('DISABLED_TOOLTIP_REFERENCE_ERROR')}
      />
    </ApplicationStepContainer>
  );
};
